import {useEffect, useState} from 'react';
import toast from '@/components/HotToast';
import {LoadingBar} from '@/components/LoadingBar';
import {useWatchPosition} from '@/map/hooks/location';
import {palette} from '@/styles';
import {ToolboxItemProps} from './';
import {ReactComponent as ButtonIcon} from './assets/current-location.svg';
import {ToolboxItem} from './StyledComponents';

export const WatchPositionController = (props: ToolboxItemProps) => {
  const {active, watch, clear, setActive} = useWatchPosition();
  const [loading, setLoading] = useState<boolean>();

  const watchPosition = async () => {
    if (!loading) {
      setLoading(true);

      try {
        await watch();
      } catch (e) {
        if (typeof e === 'string') {
          toast.error(e);
        }
      }

      setLoading(false);
    }
  };

  const onClick = () => {
    setActive(!active);
  };

  useEffect(() => {
    if (active) {
      watchPosition();
    } else {
      clear();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  useEffect(() => {
    return () => {
      clear();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ToolboxItem
      {...props}
      active={active}
      disabled={loading}
      onClick={onClick}
    >
      {loading ? (
        <LoadingBar size={16} color={palette.textSecondary} />
      ) : (
        <ButtonIcon />
      )}
    </ToolboxItem>
  );
};
